import React from "react";
import TenantAdminPage from "../pl/TenantAdminPage";

export default function TenantAdminRolesPage() {
  return <TenantAdminPage mode="roles" />;
}
